import { PageResponse } from '@src/main/shared/infrastructure/entity/page.entity';

export interface FormExcelItemDto {
  order: number | null;
  time: string;
  title: string;
}

export interface FormExcelKeyValue {
  key: string;
  order: number | null;
  value: string;
}

export interface PunctualityDetail {
  aircraftRegistration: string;
  arrivalAirport: string;
  carrierCode: string;
  departureAirport: string;
  employeeId: string;
  employeeName: string;
  flightDate: string;
  flightNumber: string;
  formId: string;
  formTitle: string;
  formType: string;
  items: FormExcelItemDto[];
  passengersKeys: FormExcelKeyValue[];
  specialSituations: FormExcelKeyValue[];
  timePlaneReady: string;
  updatedAt: string;
}

export interface SpecialSituation {
  key: string;
  quantity: string;
}

export interface Pax {
  key: string;
  quantity: string;
}

export interface PunctualityReport {
  aircraftRegistration: string;
  arrivalAirport: string;
  carrierCode: string;
  createdAt: string;
  departureAirport: string;
  employeeId: string;
  employeeName: string;
  flightDate: string;
  flightNumber: string;
  formPax: Pax[];
  formSpecialSituations: SpecialSituation[];
  formTitle: string;
  formType: string;
  id: string;
  timePlaneReady: string;
  updatedAt: string;
}
export interface PositionAssignmentReport {
  id: string | null;
  aircraftRegistration: string | null;
  arrivalAirport: string | null;
  departureAirport: string | null;
  flightDate: string | null;
  flightNumber: string | null;
}

export interface PositionAssignmentResponse {
  flight_arrival: string | null;
  flight_date: string | null;
  flight_departure: string | null;
  flight_mat: string | null;
  flight_num: string | null;
  id: string | null;
}
export interface PositionAssignmentRequest {
  flightNumber: string | null;
  flightDate: string | null;
  departureAirport: string | null;
  arrivalAirport: string | null;
  aircraftRegistration: string | null;

  flightSince: string | null;
  flightUntil: string | null;
  sortField: string | null;
  sortOrder: string | null;
  offset: number | null;
  limit: number | null;
}

export interface PositionAssignmentReportCriteria {
  aircraftRegistration: string | null;
  arrivalAirport: string | null;
  departureAirport: string | null;
  flightDate: string | null;
  flightNumber: string | null;
  formType: string | null;
  formUpdatedSince: string | null;
  formUpdatedUntil: string | null;
  limit: number;
  offset: number;
  sortField: string | null;
  sortOrder: string | null;
}

export interface PunctualityReportCriteria {
  aircraftRegistration: string | null;
  airportFrom: string | null;
  airportTo: string | null;
  carrierCode: string | null;
  employeeId: string | null;
  flightNumber: string | null;
  flightSince: string | null;
  flightUntil: string | null;
  formType: string | null;
  formUpdatedSince: string | null;
  formUpdatedUntil: string | null;
  limit: number;
  offset: number;
  sortField: string | null;
  sortOrder: string | null;
}

export const emptyPunctualityReportCriteria: PunctualityReportCriteria = {
  employeeId: null,
  airportFrom: null,
  airportTo: null,
  formUpdatedSince: null,
  formUpdatedUntil: null,
  flightSince: null,
  flightUntil: null,
  carrierCode: null,
  flightNumber: null,
  aircraftRegistration: null,
  formType: null,
  offset: 0,
  limit: 10,
  sortField: 'flight_date',
  sortOrder: 'desc',
};

export const emptyPageResponse: PageResponse<PunctualityReport> = {
  items: [],
  pageNumber: 0,
  pageSize: 0,
  total: 0,
  first: true,
  last: true,
};
